import {
  Component,
  Input,
  ViewEncapsulation,
  forwardRef,
} from '@angular/core';
import { FormsModule, NG_VALUE_ACCESSOR } from '@angular/forms';
import { BaseFormControlChild } from '@clean-code/shared/components/ui-form-controls';

@Component({
  selector: 'cc-color-picker',
  templateUrl: './color-picker.component.html',
  styleUrls: ['./color-picker.component.scss'],
  encapsulation: ViewEncapsulation.None,
  imports: [FormsModule],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => ColorPickerComponent),
      multi: true,
    },
  ],
})
export class ColorPickerComponent extends BaseFormControlChild {
  private colorInternal: string;

  public colorPalette: Array<string> = [
    '#CDCDCD',
    '#E6DF44',
    '#FFA000',
    '#B2912F',
    '#EC5800',

    '#F17CB0',
    '#CF3569',
    '#B276B2',
    '#9591A6',
    '#76A7C3',

    '#0F5D86',
    '#0AB3E3',
    '#ACDCD2',
    '#5DC3B3',
    '#8FCFA9',
  ];

  override onChange = (_value: string) => '';

  @Input()
  public position: 'left' | 'right' = 'left';

  @Input()
  public set color(val: string) {
    this.colorInternal = val || '#cdcdcd';
    this.onChange(this.colorInternal);
  }

  public get color(): string {
    return this.colorInternal;
  }

  override get value(): string {
    return this.color;
  }

  override set value(value: string) {
    this.color = value;
    this.onChange(this.color);
  }

  override writeValue(value: string) {
    // set the internal value directly: the color setter calls onChange,
    // which would mark the parent form dirty on programmatic writes
    this.colorInternal = value || '#cdcdcd';
  }

  override registerOnChange(fn: any) {
    this.onChange = fn;
  }
}
